"use client";

import { Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Vision() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: line1Ref,
    isVisible: line1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: line2Ref,
    isVisible: line2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: line3Ref,
    isVisible: line3Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: markerRef,
    isVisible: markerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3299" id="تجسم-رویای-شما-در-فضا" className="relative w-full bg-background overflow-hidden dark">
      <div className="relative min-h-screen lg:min-h-[100vh] grid grid-cols-1 lg:grid-cols-12 lg:gap-0">
        {}
        <div ref={imageRef} className={`relative order-1 lg:order-2 lg:col-span-7 lg:col-start-6 h-[55vh] sm:h-[60vh] lg:h-screen overflow-hidden transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 scale-100" : "opacity-0 scale-105"}`}>
          <div className="absolute inset-0 lg:rounded-tl-none overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/arq_interior_modern_minimalist.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/arq_interior_modern_minimalist.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/arq_interior_modern_minimalist.webp-wvc-sizes" alt="طراحی داخلی مدرن با نورپردازی هوشمند و متریال با کیفیت" loading="lazy" decoding="async" className="w-full h-full object-cover" style={{
            filter: "contrast(1.02)"
          }} />
            {}
            <div className="absolute inset-0 opacity-[0.15] mix-blend-overlay pointer-events-none" style={{
            backgroundImage: "radial-gradient(hsla(25, 75%, 55%, 0.4) 1px, transparent 1px)",
            backgroundSize: "3px 3px"
          }} />
            <div className="absolute inset-0 bg-gradient-to-br from-background/10 via-transparent to-foreground/20 pointer-events-none" />
          </div>
        </div>

        {}
        <div className="relative order-2 lg:order-1 lg:col-span-5 lg:col-start-1 flex flex-col justify-center px-6 sm:px-10 lg:px-12 xl:px-16 py-16 lg:py-24 z-10">
          {}
          <div ref={eyebrowRef} className={`mb-8 lg:mb-12 transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-mono text-[0.7rem] sm:text-xs uppercase tracking-[0.25em]" style={{
            color: "hsl(25 75% 55%)"
          }}>
              آرتین — معمار اتمسفر
            </p>
          </div>

          {}
          <h1 className="font-default font-light text-foreground leading-[0.95] text-[3.5rem] sm:text-[4.5rem] lg:text-[5.5rem] xl:text-[7rem] 2xl:text-[8rem] tracking-tight mb-8 lg:mb-10">
            <div className="overflow-hidden">
              <div ref={line1Ref} className={`transition-all duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)] ${line1Visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`}>
                تجسم رویای
              </div>
            </div>
            <div className="overflow-hidden">
              <div ref={line2Ref} className={`transition-all duration-1000 delay-150 ease-[cubic-bezier(0.22,1,0.36,1)] ${line2Visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`}>
                شما در
              </div>
            </div>
            <div className="overflow-hidden">
              <div ref={line3Ref} className={`pl-6 sm:pl-10 lg:pl-12 italic font-normal transition-all duration-1000 delay-300 ease-[cubic-bezier(0.22,1,0.36,1)] ${line3Visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`} style={{
              color: "hsl(25 75% 55%)"
            }}>
                فضا.
              </div>
            </div>
          </h1>

          {}
          <div className={`h-px w-20 mb-8 transition-all duration-700 delay-500 ease-out ${bodyVisible ? "opacity-100 scale-x-100" : "opacity-0 scale-x-0"} origin-left`} style={{
          backgroundColor: "hsl(25 75% 55%)"
        }} />

          {}
          <div ref={bodyRef} className={`max-w-[420px] mb-10 lg:mb-12 transition-all duration-700 delay-500 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-default text-base sm:text-lg leading-relaxed text-muted-foreground">
              آرتین با رویکردی مدرن و شخصی‌سازی شده، فضاهای مسکونی و تجاری شما را به تجربه‌ای الهام‌بخش و راحت تبدیل می‌کند.
            </p>
          </div>

          {}
          <div ref={ctaRef} className={`flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8 transition-all duration-700 delay-700 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Button asChild size="lg" className="h-12 px-8 bg-transparent border border-primary text-primary hover:bg-primary hover:text-primary-foreground font-mono text-base">
              <Link to="/OurProjectsPage">مشاهده پروژه‌ها</Link>
            </Button>

            <Link to="/DesignPathPage" className="group inline-flex items-center gap-2 font-mono italic text-base sm:text-lg text-foreground relative">
              <span className="relative">
                مسیر طراحی ما
                <span className="absolute left-0 -bottom-1 h-px w-full origin-left scale-x-100 transition-transform duration-500 ease-out group-hover:scale-x-0" style={{
                backgroundColor: "hsl(220 15% 8%)"
              }} />
                <span className="absolute left-0 -bottom-1 h-px w-full origin-right scale-x-0 transition-transform duration-500 delay-100 ease-out group-hover:scale-x-100" style={{
                backgroundColor: "hsl(25 75% 55%)"
              }} />
              </span>
            </Link>
          </div>

          {}
          <div ref={markerRef} className={`hidden lg:flex absolute bottom-10 left-12 xl:left-16 flex-col items-center gap-3 transition-all duration-1000 delay-1000 ease-out ${markerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <span className="font-mono text-xs tracking-[0.2em] uppercase" style={{
            color: "hsl(220 10% 45%)"
          }}>
              01
            </span>
            <div className="w-px h-16" style={{
            backgroundColor: "hsl(220 10% 45%)"
          }} />
            <Button variant="outline" size="icon" className="group w-10 h-10 border-border bg-transparent backdrop-blur-sm transition-all duration-300 hover:bg-primary hover:border-primary" aria-label="پخش نمونه کار">
              <Play className="w-3.5 h-3.5 text-foreground group-hover:text-primary-foreground transition-colors duration-300 translate-x-[1px]" fill="currentColor" />
            </Button>
          </div>
        </div>
      </div>
    </section>;
}